import React, {FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Alert} from 'reactstrap';

import Selectors from "~/state/selectors.ts";
import useEffectOnce from "~/hooks/use-effect-once.ts";
import {actions} from "~/state/reducers/worktag-reducer.ts";

function withWorktags<P>(WrappedComponent: React.ComponentType<P>) {
    const WithWorktagsComponent: FC<P> = (props) => {
        const dispatch = useDispatch();
        const metaWorktags = useSelector(Selectors.getMetaWorktags);

        useEffectOnce(() => {
            if (metaWorktags?.loadedWorktags !== true) {
                dispatch(actions.loadWorktags())
            }
        });

        return (
            <>
                {metaWorktags?.loadedWorktags ? <WrappedComponent {...props}/> :
                    <Alert className="m-4" color="info">Loading...</Alert>}
            </>
        );
    }

    return WithWorktagsComponent;
}

export default withWorktags;
